import Vue from 'vue'
import WorldMapVue from 'vue-geo-heat-maps'

Vue.component('WorldMapVue', WorldMapVue)
